import React from 'react'
import { Button, Card, Divider, Header, Icon } from 'semantic-ui-react'
import _ from 'lodash'

import Placeholder from './storePlaceholder'
import OptionCard from './itemOptionCard'
import ItemOptionLinker from './itemOptionLinker'
import ItemOptionForm from '../forms/itemOptionForm'
import CloneForm from '../forms/cloneItemOptionForm'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 14px',
  },
  header: {
    display: 'flex',
    alignItems: 'center'
  },
  addIconWrapper: {
    display: 'flex'
  },
  optionsWrapper: {
    overflow: 'auto'
  },
  optionNameWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
}

class ItemOptions extends React.Component {
  state = {
    formVisible: false,
    itemOption: null,
    linkerModalVisible: false,
    cloneModalVisible: false,
  }

  onEditClick = itemOption => {
    this.setState({
      itemOption,
      formVisible: true,
    })
  }

  renderOptions = () => {
    const { itemOptions, storeId } = this.props
    const merchantItemOptions = itemOptions[storeId]

    return (
      <Card.Group style={{ margin: 0 }}>
        {
          _.map(merchantItemOptions, (option, optionKey) => (
            <OptionCard
              key={optionKey}
              option={option}
              onEditClick={() => this.onEditClick(option)}
            />
          ))
        }
      </Card.Group>
    )
  }

  renderContent = () => {
    const { formVisible, itemOption, linkerModalVisible, cloneModalVisible } = this.state
    const { storeId, itemOptions } = this.props
    const itemOptionCount = _.size(itemOptions[storeId])

    return (
      <React.Fragment>
        <div style={styles.container}>
          <div style={styles.headerWrapper} >
            <div style={styles.header}>
              <Header>Options ({itemOptionCount})</Header>
            </div>
            <div style={styles.addIconWrapper}>
              <Button
                icon
                disabled={itemOptionCount === 0}
                color="black"
                onClick={() => this.setState({ linkerModalVisible: true })}
              >
                <Icon name="linkify" /> Link Options To Items
              </Button>
              <Button icon color="black" onClick={() => this.setState({ cloneModalVisible: true })}>
                <Icon name="copy" /> Copy from Existing
              </Button>
              <Button icon color="black" onClick={() => this.setState({ formVisible: true }) }>
                <Icon name="add" /> Add New Option
              </Button>
            </div>
          </div>
          <div>
            <Divider style={{ margin: 14 }} />
          </div>

          <div style={styles.optionsWrapper} className="branches-summary">
            {this.renderOptions()}
          </div>
        </div>
        {
          formVisible &&
            <ItemOptionForm
              visible={formVisible}
              action={ itemOption ? 'edit' : 'new' }
              onClose={() => this.setState({ formVisible: false, itemOption: null })}
              storeId={storeId}
              itemOption={itemOption}
            />
        }
        {
          linkerModalVisible &&
            <ItemOptionLinker
              storeId={storeId}
              visible={linkerModalVisible}
              onClose={() => this.setState({ linkerModalVisible: false })}
            />
        }
        {
          cloneModalVisible &&
            <CloneForm
              storeId={storeId}
              visible={cloneModalVisible}
              onItemOptionClick={nextItemOption => this.setState({ itemOption: nextItemOption })}
              onClose={() => this.setState({ cloneModalVisible: false })}
            />
        }
      </React.Fragment>
    )
  }

  renderLoading = () => <Placeholder />

  render() {
    const { loading, itemOptions } = this.props

    if (loading) {
      return this.renderLoading()
    }

    if (itemOptions) {
      return this.renderContent()
    }

    return null
  }
}

export default ItemOptions



// WEBPACK FOOTER //
// ./src/components/restaurants/views/itemOptionsList.js